module.exports = new __parcel__URL__("shop_machines_porcelain_throne.4efbac0b.png").toString();